module.exports = __webpack_public_path__ + "img/7ibr.380d56af.png";